import React from 'react';
import PropTypes from 'prop-types';

import styles from './Background.m.sass';

export default function Background() {
  return (
    <div className={styles.background}/>
  );
}



// WEBPACK FOOTER //
// ./components/background/Background.js